import { ClientDataService, IClientDataDoc } from '../../../../services/clientData.service'

export class CardiacService extends ClientDataService {
  private ACTION_DOC = 'cardiacaction_tb_prprocedure_action'
  private LEAD_CHANGE_DOC = 'tb_nhtsa_ecglead'
  private DEFIB_TYPE_DOC = 'tb_cardiac_defib_type'
  private TYPE_DOC = 'tb_cardiac_phase_type'

  async getActionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ACTION_DOC)
  }

  async getLeadChangeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.LEAD_CHANGE_DOC)
  }

  async getDefibTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DEFIB_TYPE_DOC)
  }

  async getTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TYPE_DOC)
  }
}
